import * as dayjs from "dayjs";
import * as weekOfYear from "dayjs/plugin/weekOfYear";
import * as weekday from "dayjs/plugin/weekday";

dayjs.extend(weekOfYear);
dayjs.extend(weekday);

const DAYS = { sun: 7, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };

type Frequency = "even" | "odd" | "both" | "none";

const readQueryParams = () => {
  const searchParams = new URL(window.location.href).searchParams;
  const dayParam = searchParams.get("day");
  const day = dayParam && dayParam in DAYS ? DAYS[dayParam] : 1;
  const redParam = searchParams.get("red");
  const yellowParam = searchParams.get("yellow");
  const greenParam = searchParams.get("green");

  // Validate frequency values
  const isValidFrequency = (freq: string | null): freq is Frequency => {
    return (
      freq === "even" || freq === "odd" || freq === "both" || freq === "none"
    );
  };

  let red: Frequency = "both";
  let yellow: Frequency = "even";
  let green: Frequency = "odd";

  if (redParam !== null) {
    if (isValidFrequency(redParam)) {
      red = redParam;
    } else {
      console.warn(
        `Invalid frequency for red: "${redParam}". Defaulting to "both".`,
      );
      red = "both";
    }
  }

  if (yellowParam !== null) {
    if (isValidFrequency(yellowParam)) {
      yellow = yellowParam;
    } else {
      console.warn(
        `Invalid frequency for yellow: "${yellowParam}". Defaulting to "even".`,
      );
      yellow = "even";
    }
  } else {
    yellow = "even";
  }

  if (greenParam !== null) {
    if (isValidFrequency(greenParam)) {
      green = greenParam;
    } else {
      console.warn(
        `Invalid frequency for green: "${greenParam}". Defaulting to "odd".`,
      );
      green = "odd";
    }
  } else {
    green = "odd";
  }

  return { day, red, yellow, green };
};

const isEven = (value: number) => value % 2 === 0;

const isOdd = (value: number) => !isEven(value);

const isDue = (weekNumber: number, frequency: Frequency): boolean => {
  switch (frequency) {
    case "even":
      return isEven(weekNumber);
    case "odd":
      return isOdd(weekNumber);
    case "both":
      return true;
    case "none":
      return false;
  }
};

const updateColour = (date = dayjs()) => {
  const { day, red, yellow, green } = readQueryParams();
  const binDay = dayjs().weekday(day).endOf("day");
  const weekNumber = dayjs().week();

  // Determine effective week: this week if before collection day, next week if after
  const effectiveWeek = weekNumber + (date > binDay ? 1 : 0);

  // Check which bins are due this effective week
  const dueBins: string[] = [];
  if (isDue(effectiveWeek, red)) dueBins.push("red");
  if (isDue(effectiveWeek, yellow)) dueBins.push("yellow");
  if (isDue(effectiveWeek, green)) dueBins.push("green");

  console.debug(`Bin Night Debug:`, {
    day,
    red,
    yellow,
    green,

    weekNumber,
    effectiveWeek,
    dueBins,
    date: date.format(),
    binDay: binDay.format(),
    isAfterCollection: date > binDay,
  });

  // Update bin display
  const container = document.getElementById("bin-container");
  if (container) {
    // Ensure container is visible
    container.style.display = "flex";

    // Update each bin's color and visibility
    const colors = ["red", "yellow", "green"];
    colors.forEach((color) => {
      const bin = document.getElementById(`bin-${color}`);
      if (bin) {
        const isDue = dueBins.indexOf(color) !== -1;
        bin.style.display = isDue ? "flex" : "none";
        bin.style.backgroundColor = isDue ? color : "#ccc";
      }
    });
  }
};

const run = () => {
  console.info("Bin Night - Collection Day Reminder");
  console.info('Required parameter: "day" (collection day)');
  console.info('  - One of "mon", "tue", "wed", "thu", "fri", "sat", "sun"');
  console.info("");
  console.info("Frequency parameters (optional, default shown):");
  console.info(
    '  - "red"    : "even" | "odd" | "both" | "none" (default: "both")',
  );
  console.info(
    '  - "yellow" : "even" | "odd" | "both" | "none" (default: "even")',
  );
  console.info(
    '  - "green"  : "even" | "odd" | "both" | "none" (default: "odd")',
  );
  console.info("");
  console.info("Examples:");

  console.info("  - New format: ?day=mon&red=both&yellow=even&green=odd");
  console.info("  - Weekly red: ?day=mon&red=both&yellow=none&green=none");
  console.info("");
  console.info("Shows which bins are due for the next collection.");

  // Ensure bin container exists
  const container = document.getElementById("bin-container");
  if (!container) {
    console.error("Bin container not found in HTML");
    return;
  }

  updateColour();
  console.debug("Initial update complete");
  setInterval(updateColour, 60 * 1000);
};

run();
